import React from 'react';

import LessonDescription from '@/components/EditorViewer/LessonDescription';
import { useArticle } from '@/modules/corporate/modules/article/articleContext';
import { DEFAULT_ARTICLE_DESCRIPTION } from '@/modules/corporate/modules/article/consts';

import { DescriptionContainerProps } from './types';

const DescriptionContainer: React.FC<DescriptionContainerProps> = () => {
  const {
    articleContent: { description },
  } = useArticle();

  return (
    <>
      {description ? (
        <LessonDescription description={description} placeholder={DEFAULT_ARTICLE_DESCRIPTION} />
      ) : null}
    </>
  );
};

export default React.memo(DescriptionContainer);
